module.exports = __webpack_public_path__ + "static/media/shopeePay.3bf2f8f1.svg";